import { Component } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-zpt-plans',
  templateUrl: './zpt-plans.page.html',
  styleUrls: ['./zpt-plans.page.scss'],
})
export class ZptPlansPage {
  // declared variables
  public assets = environment.assets;
  public activePlan: any;
  public date: any;
  public zptforecast = environment.zptforecast;
  public zptshifts = environment.zptshifts;
  public refreshIcon = false;
  //constructor
  constructor() {
    this.activePlan = 'forecast';
  }
  // refreshes the images
  public doRefresh() {
    this.refreshIcon = true;
    this.date = Date.now();
    setTimeout(() => {
      this.zptforecast = environment.zptforecast + this.date;
      this.zptshifts = environment.zptshifts + this.date;
      this.refreshIcon = false;
    }, 2000);
  }

}
